import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'

const Zprotocols = z.object({
  commTypeId: z.string(),
  commType: z.string()
})

const ZdataTypes = z.object({
  endianTypeId: z.string(),
  endianType: z.string()
})

const ZData = z.object({
  protocols: Zprotocols.array(),
  dataTypes: ZdataTypes.array()
})

const ZApiResponse = z.object({
  http_status: z.number(),
  error: z.boolean(),
  data: ZData
})

export type getDeviceDropDownMetaDetails = z.infer<typeof ZApiResponse>
export type DeviceDropDownMetaDetails = z.infer<typeof ZData>

export async function getDeviceDropDownMeta (
  onSuccess: (DeviceDropDownMetaDetails: DeviceDropDownMetaDetails, httpStatus: number) => any,
  onFailure: (errorMessage: any, httpStatus: number) => any
): Promise<void> {
  const url = '/asset-config-service/api/v1/udp/tiq/commands/configuration/device-template/metadata'
  interceptedAxios
    .get(url, { timeout: 10000 })
    .then((response) => {
      // istanbul ignore next
      if (response.status === 200) {
        const parseResponse = ZApiResponse.safeParse(response.data)
        if (parseResponse.success) {
          if (response.data.data !== null && response.data.data !== undefined) {
            onSuccess(parseResponse.data.data, response.status)
          }
        } else {
          onFailure(parseResponse.error.message, response.status)
        }
      }
    })
    .catch((error) => {
      onFailure(error.message, error.status)
    })
}
